class WoodifyOffer extends HTMLElement {
  connectedCallback() {
    document.documentElement.classList.add('wd-offer-page');

    const price = Number(this.dataset.value || 199000);
    const payload = { content_name: 'Woodify 199K Full Furniture Offer', content_category: 'Furniture package', value: price, currency: 'EGP' };
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: 'woodify_offer_view', ...payload });
    if (typeof window.fbq === 'function') window.fbq('track', 'ViewContent', payload);

    this.querySelectorAll('[data-offer-track]').forEach((element) => {
      element.addEventListener('click', () => {
        const action = element.dataset.offerTrack || 'cta_click';
        window.dataLayer.push({ event: `woodify_${action}`, ...payload });
        if (typeof window.fbq === 'function') window.fbq('track', action === 'lead' ? 'Lead' : 'Contact', payload);
      });
    });

    this.querySelector('form')?.addEventListener('submit', () => {
      window.dataLayer.push({ event: 'woodify_lead_submit', ...payload });
      if (typeof window.fbq === 'function') window.fbq('track', 'Lead', payload);
    });

    this.querySelectorAll('[data-offer-carousel]').forEach((carousel) => {
      const track = carousel.querySelector('[data-offer-track-list]');
      const previous = carousel.querySelector('[data-offer-prev]');
      const next = carousel.querySelector('[data-offer-next]');
      if (!track || !previous || !next) return;

      const amount = () => Math.max(track.clientWidth * 0.82, 280);
      const direction = getComputedStyle(track).direction === 'rtl' ? -1 : 1;
      previous.addEventListener('click', () => track.scrollBy({ left: -amount() * direction, behavior: 'smooth' }));
      next.addEventListener('click', () => track.scrollBy({ left: amount() * direction, behavior: 'smooth' }));
    });

    this.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
      const track = gallery.querySelector('[data-product-track]');
      const slides = track ? Array.from(track.children) : [];
      const previous = gallery.querySelector('[data-product-prev]');
      const next = gallery.querySelector('[data-product-next]');
      const counter = gallery.querySelector('[data-product-counter]');
      if (!track || slides.length < 2 || !previous || !next) return;

      let index = 0;
      let pointerStart = null;
      const show = (newIndex) => {
        index = (newIndex + slides.length) % slides.length;
        track.style.transform = `translate3d(-${index * 100}%, 0, 0)`;
        if (counter) counter.textContent = `${index + 1} / ${slides.length}`;
      };

      previous.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        show(index - 1);
      });
      next.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        show(index + 1);
      });
      gallery.addEventListener('pointerdown', (event) => {
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        pointerStart = { x: event.clientX, y: event.clientY };
      });
      gallery.addEventListener('pointerup', (event) => {
        if (pointerStart === null) return;
        const distanceX = event.clientX - pointerStart.x;
        const distanceY = event.clientY - pointerStart.y;
        pointerStart = null;
        // A vertical gesture always belongs to the page, not the image slider.
        if (Math.abs(distanceX) > 42 && Math.abs(distanceX) > Math.abs(distanceY) * 1.2) {
          show(distanceX < 0 ? index + 1 : index - 1);
        }
      });
      gallery.addEventListener('pointercancel', () => { pointerStart = null; });
    });
  }
}
if (!customElements.get('woodify-offer')) customElements.define('woodify-offer', WoodifyOffer);

class WoodifyOfferContact extends HTMLElement {
  connectedCallback() {
    const basePayload = { content_name: 'Woodify 199K Full Furniture Offer', content_category: 'Furniture package', value: Number(this.dataset.value || 199000), currency: 'EGP' };
    window.dataLayer = window.dataLayer || [];
    const form = this.querySelector('[data-offer-buy-form]');
    if (!form) return;

    const variantSelect = form.querySelector('[data-offer-variant-select]');
    const priceElement = this.querySelector('[data-offer-product-price]');
    const button = form.querySelector('[data-offer-track="buy_now"]');
    const errorElement = form.querySelector('[data-offer-checkout-error]');

    variantSelect?.addEventListener('change', () => {
      const option = variantSelect.selectedOptions[0];
      if (priceElement && option?.dataset.price) priceElement.textContent = option.dataset.price;
    });

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (!button || button.disabled) return;

      const formData = new FormData(form);
      const variantId = String(formData.get('id') || '');
      const selectedOption = variantSelect?.selectedOptions[0];
      const priceCents = Number(selectedOption?.dataset.priceCents || Math.round(basePayload.value * 100));
      const payload = { ...basePayload, value: priceCents / 100, content_ids: [variantId], content_type: 'product' };
      const root = window.Shopify?.routes?.root || '/';

      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      if (errorElement) {
        errorElement.hidden = true;
        errorElement.textContent = '';
      }

      try {
        const response = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          credentials: 'same-origin',
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: formData,
        });
        if (!response.ok) throw new Error('Unable to add the offer to cart');

        window.dataLayer.push({ event: 'woodify_add_to_cart', ...payload });
        window.dataLayer.push({ event: 'woodify_initiate_checkout', ...payload });
        if (typeof window.fbq === 'function') {
          window.fbq('track', 'AddToCart', payload);
          window.fbq('track', 'InitiateCheckout', payload);
        }
        window.location.assign(`${root}checkout`);
      } catch (error) {
        button.disabled = false;
        button.removeAttribute('aria-busy');
        if (errorElement) {
          errorElement.textContent = form.dataset.errorMessage || 'Please try again.';
          errorElement.hidden = false;
        }
      }
    });
  }
}
if (!customElements.get('woodify-offer-contact')) customElements.define('woodify-offer-contact', WoodifyOfferContact);
